import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CompanyComment } from 'app/modules/coordinator/entities/company-comment';

@Component({
    selector: 'app-comment-popup',
    templateUrl: './comment-popup.component.html',
    styleUrls: ['./comment-popup.component.scss'],
    standalone: false
})
export class CommentPopupComponent implements OnInit {

  public commentData: CompanyComment;
  
  constructor(private dialogRef: MatDialogRef<CommentPopupComponent>) { }

  ngOnInit(): void {
  }

  public cancel(): void {
    this.dialogRef.close();
  }

}
